module.exports = __webpack_public_path__ + "static/media/newsurf-graphic-design.d972618a.jpg";